import React, { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { PermissionTooltip, LibraryDetailsHoverTooltip } from 'ui/components/tooltip'
import ControlButton from '../sections/devices/components/ControlButton'
import theme from 'theme'
import { hasPermission, isViewerRole, Permission } from 'lib/utils'
import { User } from '@frontegg/redux-store'

const popperProps = {
  sx: {
    marginTop: `-${theme.spacing.sm}px !important`
  }
}

interface SettingsButtonProps {
  authUser: User | null | undefined
  handleOpenDrawer: () => void
}

const SettingsButton: FC<SettingsButtonProps> = ({ authUser, handleOpenDrawer }) => {
  const isDisabled = isViewerRole(authUser) || !hasPermission(Permission.CPIConfigIntegrationView, authUser)

  if (isDisabled) {
    return (
      <PermissionTooltip
        PopperProps={popperProps}
        title={
          <Box className="tooltip-wrapper-permissions">
            <Typography className="tooltip-text">Insufficient permissions</Typography>
          </Box>
        }
      >
        <ControlButton type="settings" />
      </PermissionTooltip>
    )
  }

  return (
    <LibraryDetailsHoverTooltip title="Activate CPI" placement="bottom-end">
      <div>
        <ControlButton type="settings" handleClick={handleOpenDrawer} />
      </div>
    </LibraryDetailsHoverTooltip>
  )
}

export default SettingsButton
